(function () {
  'use strict';

  var tableRegionIndex = 0;
  var observedTableRegions = new WeakSet();
  var tableRegionObservers = [];

  function tableRegionLabel(table) {
    var details = table.closest('.phq-accordion');
    var summary = details ? details.querySelector('summary') : null;
    var caption = table.querySelector('caption');
    var context = caption && caption.textContent.trim()
      ? caption.textContent.trim()
      : summary && summary.textContent.trim()
        ? summary.textContent.trim()
        : 'Product information';

    return context + ' table';
  }

  function updateTableRegion(region) {
    var hasHorizontalOverflow = region.scrollWidth > region.clientWidth + 1;
    region.toggleAttribute('data-phq-v1712-scrollable', hasHorizontalOverflow);

    if (hasHorizontalOverflow) {
      region.setAttribute('tabindex', '0');
      region.setAttribute('role', 'region');
      region.setAttribute('aria-label', region.dataset.phqV1712Label + ', horizontally scrollable');
    } else {
      region.removeAttribute('tabindex');
      region.removeAttribute('role');
      region.removeAttribute('aria-label');
    }
  }

  function observeTableRegion(region) {
    if (observedTableRegions.has(region)) return;
    observedTableRegions.add(region);
    updateTableRegion(region);

    region.addEventListener('keydown', function (event) {
      if (!region.hasAttribute('data-phq-v1712-scrollable')) return;
      var step = Math.max(40, Math.round(region.clientWidth * 0.8));
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        region.scrollLeft += step;
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        region.scrollLeft -= step;
      } else if (event.key === 'Home') {
        event.preventDefault();
        region.scrollLeft = 0;
      } else if (event.key === 'End') {
        event.preventDefault();
        region.scrollLeft = region.scrollWidth;
      }
    });

    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(function () { updateTableRegion(region); });
      observer.observe(region);
      tableRegionObservers.push(observer);
    }
  }

  function prepareProductTables(scope) {
    scope.querySelectorAll('.phq-product-page .phq-accordion-content table').forEach(function (table) {
      var region = table.closest('.phq-v1712-table-scroll');
      if (!region) {
        region = document.createElement('div');
        region.className = 'phq-v1712-table-scroll';
        region.dataset.phqV1712TableRegion = '';
        region.dataset.phqV1712Label = tableRegionLabel(table);
        region.id = 'phq-v1712-table-region-' + (++tableRegionIndex);
        table.parentNode.insertBefore(region, table);
        region.appendChild(table);
      }
      observeTableRegion(region);
    });
  }

  function initialise(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;
    prepareProductTables(target);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  } else {
    initialise(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialise(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    initialise(event.target);
  });
})();
